
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 45 50"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"currentColor","stroke":"currentColor","stroke-width":".5","d":"M3.967.473A3.623 3.623 0 00.347 4.09v30.904a3.621 3.621 0 003.618 3.618H9.42v10.345a.435.435 0 00.741.31l10.659-10.652h20.21a3.621 3.621 0 003.617-3.618l.005-30.907a3.623 3.623 0 00-3.62-3.617H3.967zm39.817 34.522a2.754 2.754 0 01-2.75 2.75H20.644a.435.435 0 00-.306.127L10.293 47.91v-9.732a.435.435 0 00-.435-.435h-5.89a2.75 2.75 0 01-2.752-2.748V4.091a2.754 2.754 0 012.751-2.75h37.069a2.754 2.754 0 012.75 2.75l-.002 30.904z"}}),_c('path',{attrs:{"stroke":"#BF9C5F","stroke-width":"2","d":"M36.534 20.786a3.26 3.26 0 00-4.574.005l-.636.627-.695-.561a3.262 3.262 0 00-4.353.23 3.259 3.259 0 00-.255 4.315l5.237 5.237 5.273-5.273a3.26 3.26 0 00.003-4.58zm0 0a3.346 3.346 0 00-.004-.004l.009.009a3.41 3.41 0 00-.005-.005z"}})])])
          )
        }
      }
    